import { Route } from "react-router-dom";

import React from "react";
import Dashboard from "../Views/Dashboard";
import Protected from "./Protected";
import CreateAccountPage from "../Views/CreateAccount/CreateAccountPage";

import SellerDetails from "../Views/CreateAccount/SellerDetails";
import StoreTiming from "../Views/CreateAccount/StoreTiming";
import BankDetails from "../Views/CreateAccount/BankDetails";
import StoreImages from "../Views/CreateAccount/StoreImages";
import Orders from "../Views/Orders";
import OrdersView from "../Views/OrdersView";
import ProductList from "../Views/MenusPages/Productlist";
import AddProduct from "../Views/MenusPages/AddProduct";
import CategoryPage from "../Views/MenusPages/CategoryPage";
import Account from "../Views/Account";
import ShopList from "../Views/Accounts/ShopList";
import UserAccount from "../Views/Accounts/UserAccounts";
import MenuManager from "../Views/MenuPages/MenuManager";
// import Coupons from "../Views/Coupons/Coupons";

import FinanceReport from "../Views/FinancePages/InvoicesFinance";
import Reviews from "../Views/SalesPages/Reviews";
import Coupons from "../Views/Coupons/Coupons";
import Chatlists from "../Views/Chats/chatlist";
import Chatbox from "../Views/Chats/chatbox";
import SignIn from "../Views/SignIn";
import ForgotPassword from "../Views/ForgotPassword";
import OtpVerification from "../Views/OtpVerification";
import Register from "../Views/Register";
import Changepass from "../Views/changepassword";
import StoreSeo from "../Views/Accounts/StoreSeo";
import Layout from "../layouts/Layout";
import AuthLayout from "../layouts/AuthLayout";

export const AllRoutes = (Auth) => {


  console.log('authcheckroute', Auth)


  return (
    <>

      {/* <Route path="/" element={Auth ? <Dashboard /> : <SignIn />} /> */}

      <Route path="/" element={<AuthLayout isSignedIn={Auth} />}>

        <Route path="/register" element={<Register />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/forgotpw" element={<ForgotPassword />} />
        <Route path="/otpverification" element={<OtpVerification />} />
        <Route path="/createaccount" element={<CreateAccountPage />} />
        <Route path="/sellerdetail" element={<SellerDetails />} />
        <Route path="/storetiming" element={<StoreTiming />} />
        <Route path="/bankdetails" element={<BankDetails />} />
        <Route path="/Storeimage" element={<StoreImages />} />
        <Route path="/Changepass" element={<Changepass />} />

      </Route>


      {/* UserRoutes */}

      <Route path="/" element={<Layout isSignedIn={Auth} />}>

        <Route path="/store-faq/:id" element={<StoreSeo />} />
        <Route path="/add-store-faq/:id" element={<StoreSeo />} />
        <Route path="/edit-store-faq/:id/:_id" element={<StoreSeo />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orderdetail" element={<OrdersView />} />
        <Route path="/orderdetail" element={<OrdersView />} />
        <Route path="/category" element={<CategoryPage />} />
        <Route path="/ProductList" element={<ProductList />} />
        <Route path="/editproduct" element={<AddProduct />} />
        <Route path="/addproduct" element={<AddProduct />} />
        <Route path="/account/operation" element={<Account />} />
        <Route path="/account" element={<Account />} />
        <Route path="/addaccount" element={<Account />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/shoplist" element={<ShopList />} />
        <Route path="/shoplist" element={<ShopList />} />
        <Route path="/accounts" element={<UserAccount />} />
        <Route path="/menumanager" element={<MenuManager />} />
        <Route path="/coupons" element={<Coupons />} />
        <Route path="/financereport" element={<FinanceReport />} />
        <Route path="/chatlists" element={<Chatlists />} />
        <Route path="/chatbox" element={<Chatbox />} />

      </Route >

    </>
  );
};
